module.exports = __webpack_public_path__ + "media/paliwa/lpg@2x-18953926.png";